import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const commvaultMetallic = defineConnector({
  identifier: "commvaultMetallic",
  name: "Commvault Metallic",
  tagLine: "Cloud backup and recovery",
  keywords: "commvault cloud metallic backup restore recovery",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.metallic\\.io/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://api.metallic.io/Login",
        headers: [{ name: "Accept", value: "application/json" }],
        jsonBody: {
          username: app.secret.username,
          password: { from: "base64Secret", field: "password" },
        },
      },
      extract: { from: "jsonPath", paths: ["data.authToken"] },
      apply: { kind: "header", scheme: "Bearer" },
      cache: { ttlSeconds: 1200 },
    }),
  steps: [
    {
      title: "Enter your Commvault credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Use a dedicated Commvault Cloud user with [API login access](https://api.commvault.com/docs/latest/api/cv/AuthenticationOperations/login/) and permission to list clients. Passwordless service accounts cannot use this connector.",
        },
        {
          kind: "input",
          label: "Email address",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.metallic.io/Client",
      method: "GET",
      headers: { Accept: "application/json" },
      expectedStatus: 200,
      expectedBodyContains: '"clientProperties"',
    }),
  },
  usageHint: () =>
    "Use the Commvault Cloud REST API at https://api.metallic.io. Bearer authentication is added automatically. Send Accept: application/json. Available operations depend on the user’s permissions. API reference: https://api.commvault.com/docs/latest/commvault-rest-api-public/.",
});
